import ContactForm from './ContactForm'
import { useTranslation } from 'react-i18next'

export default function ContactBanner() {
  const { t } = useTranslation()
  return (
    <section className='flex justify-center py-12 sm:py-24'>
      <div className='w-[92%] lg:w-5/6 flex flex-col xl:flex-row gap-8 2xl:gap-16'>
        <div className='w-full xl:w-3/5 2xl:w-2/3'>
          <div className='w-full lg:mb-0'>
            <h2 className='sm:text-4xl text-2xl uppercase font-[700] sm:mb-2'>
              {t('contactSection.title')}
            </h2>
            <div className='h-1 w-20 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full'></div>
          </div>
          <h3 className='mt-2 sm:mt-4 text-xl text-gray-600 drop-shadow-md font-normal'>
            {t('contactSection.content')}
          </h3>
        </div>
        <div className='w-full 2xl:w-1/3'>
          <ContactForm />
        </div>
      </div>
    </section>
  )
}
